<!-- 分页组件 -->
<template>
  <div class="pagination">
    <el-pagination small class="text-center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page.page" :page-sizes="pageSizes" :page-size="page.limit" :layout="layout" :total="total"
      ref="pagination">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    name: "Pagination",
    total: {
      type: Number,
    }, // 总条数
    layout: {
      type: String,
    }, // 总条数
  },

  data() {
    return {
      pageSizes: [5, 10, 15, 30],
      // layout:"total, sizes, prev, pager, next, jumper",
      page: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    // 每页条数变更
    handleSizeChange(val) {
      this.page.limit = val;
      this.page.page = 1;
      this.$emit("pageChange", this.page);
    },
    // 当前页码变更
    handleCurrentChange(val) {
      this.page.page = val;
      //  this.$refs.pagination.internalCurrentPage = 1;
      this.$emit("pageChange", this.page);
    },
  },
  watch: {
    total(newdata, olddata) {
      if (newdata != olddata) {
        this.$refs.pagination.internalCurrentPage = 1;
        this.page.limit = 10;
      }
    },
  },
};
</script>
<style scoped>
.pagination {
  margin: 20px 0;
}

.el-pager li {
  background-color: transparent !important;
  color: #131314 !important;
  border: 1px solid #d1d3d4;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #db3a3b !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pagination.vue